import { ASSIGNMENTS } from './endpoints';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AssignmentService extends BaseService {

    constructor(http: HttpClient) {
        super(http);
    }

    getItems(assignmentParams: any): Observable<any> {
        const url = ASSIGNMENTS + '?' + this.makeQueryString(assignmentParams);
        return this.getRequest(url, null);
    }

    getAssignmentById(assignmentId: any): Observable<any> {
        const url = ASSIGNMENTS + '/' + assignmentId;
        return this.getRequest(url, null);
    }

    save(data){
        const url = ASSIGNMENTS;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return  this.postRequest(url,data,options);
    }

    update(assignmentId: number, updateParams: any): Observable<any> {
        const url = ASSIGNMENTS + '/' + assignmentId;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return this.putRequest(url, updateParams, options);
    }

}
